'use client'

import { useTranslation } from '../../hooks/useTranslation';

export default function GetInTouch() {
  const { t } = useTranslation();

  // WhatsApp Click Handler
    const handleWhatsAppClick = () => {
        const phoneNumber = "971507946317"; // without +
        const message = `Hello, I am interested in the connecting with you !`;
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    };

    // Call Click Handler
    const handleCallClick = () => {
        window.location.href = `tel:'+974507946317'}`;
    };
  return (
      <section className="py-4 sm:py-6 xl:pr-[0] bg-[#006FFF] text-white" id="contact">
        <div className="mx-auto px-4 sm:px-6 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-0">
          <h2 className="text-lg sm:text-xl pl-9 font-semibold text-center sm:text-left">{t('getinTouch')}</h2>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3 w-full sm:w-auto">
            <button onClick={handleCallClick} className="bg-white text-[#006FFF] px-4 sm:px-6 py-2 rounded-[15px] font-bold hover:bg-gray-100 transition-colors text-sm w-full sm:w-auto">
             {t('makeacall')}
            </button>
            <button onClick={handleWhatsAppClick} className="bg-white text-[#006FFF] px-4 sm:px-6 py-2 rounded-[15px] font-bold hover:bg-gray-100 transition-colors text-sm w-full sm:w-auto">
              {t('sendmsg')}
            </button>
          </div>
        </div>
      </section>
  )
}